import { Separator } from "@/components/ui/separator";
import { ThemeToggle } from "./theme-toggle";
import { UserMenu } from "./user-menu";

export function Topbar() {
  return (
    <header className="flex h-14 items-center justify-end gap-2 border-b bg-card px-4">
      <ThemeToggle />
      <Separator orientation="vertical" className="h-6" />
      <UserMenu />
    </header>
  );
}
